import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { createSelector } from 'reselect';
import { LayoutType } from '../../../types/layouts.esm.js';
import { getSelectedLayout } from '../../../utilities/get-selected-layout.esm.js';
import { removeLayout } from '../../../utilities/remove-layout.esm.js';
import { getCommands } from '../../../utilities/get-commands.esm.js';

var validate = function validate(type) {
  switch (type) {
    case LayoutType.Default:
      throw new Error('You cannot use the "delete" function for the default layout.');
    case LayoutType.Predefined:
      throw new Error('You cannot use the "delete" function for the predefined layout.');
    case LayoutType.Custom:
      throw new Error('You cannot use the "delete" function for the predefined layout.');
    case LayoutType.Saved:
      {
        return;
      }
    default:
      throw new Error('Unknown type.');
  }
};
var getNewLayoutsFromDeleteAction = function getNewLayoutsFromDeleteAction(layouts) {
  var currentLayout = getSelectedLayout(layouts);
  validate(currentLayout.type);
  return layouts.filter(function (l) {
    return !l.selected;
  }).map(function (l) {
    if (l.type !== LayoutType.Default) {
      return l;
    }
    return _objectSpread2(_objectSpread2({}, l), {}, {
      selected: true
    });
  });
};
function executeCallbackForDisplayValue(displayLayouts, setDisplayLayouts) {
  var newLayouts = getNewLayoutsFromDeleteAction(displayLayouts);
  if (displayLayouts !== newLayouts) {
    setDisplayLayouts(newLayouts);
  }
}
function executeCallbackForValue(_x, _x2, _x3, _x4, _x5) {
  return _executeCallbackForValue.apply(this, arguments);
}
function _executeCallbackForValue() {
  _executeCallbackForValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(displayLayouts, layouts, onChange, onSaveLayout, onDeleteLayout) {
    var selectedLayout, newLayouts;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          selectedLayout = getSelectedLayout(displayLayouts);
          newLayouts = removeLayout(layouts, selectedLayout.id);
          if (!(layouts !== newLayouts)) {
            _context2.next = 6;
            break;
          }
          onChange(newLayouts);
          _context2.next = 6;
          return getCommands({
            onSaveLayout: onSaveLayout,
            onDeleteLayout: onDeleteLayout
          })(layouts, newLayouts);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _executeCallbackForValue.apply(this, arguments);
}
function getDeleteCallback(layouts, onChange, displayLayouts, setDisplayLayouts, onSaveLayout, onDeleteLayout) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return executeCallbackForValue(displayLayouts, layouts, onChange, onSaveLayout, onDeleteLayout);
        case 2:
          executeCallbackForDisplayValue(displayLayouts, setDisplayLayouts);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
var createDeleteCallbackSelector = function createDeleteCallbackSelector() {
  return createSelector(function (props) {
    return props.layouts;
  }, function (props) {
    return props.onChange;
  }, function (props) {
    return props.displayLayouts;
  }, function (props) {
    return props.setDisplayLayouts;
  }, function (props) {
    return props.onSaveLayout;
  }, function (props) {
    return props.onDeleteLayout;
  }, getDeleteCallback);
};

export { createDeleteCallbackSelector, getDeleteCallback, getNewLayoutsFromDeleteAction, validate };
//# sourceMappingURL=delete-callback-selector.esm.js.map
